let routes = [
	{
		path:'/login',
		name:'登录',
		component: (resolve) => require(['./components/login.vue'], resolve)
	},
	{
		path:'/',
		name:'',
		component: (resolve) => require(['./components/Home.vue'], resolve),
		children:[
			{
				path:'/sendSalaryBill',
				name:'工资条发放',
				component: (resolve) => require(['./components/sendSalaryBill.vue'], resolve)
			},
			{
				path:'/employeeInfo',
				name:'员工资料',
				component: (resolve) => require(['./components/employeeInfo.vue'], resolve)
			},
			{
				path:'/feedback',
				name:'问题反馈',
				component: (resolve) => require(['./components/feedback.vue'], resolve)
			},
			{
				path:'/resetPassword',
				name:'密码重置',
				component: (resolve) => require(['./components/resetPassword.vue'], resolve)
			},
			{
				path:'/downloadRecord',
				name:'操作日志',
				component: (resolve) => require(['./components/downloadRecord.vue'], resolve)
			}
		]
	}
  ]

export default routes;



// WEBPACK FOOTER //
// ./src/routers.js